import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-send-files',
  templateUrl: './send-files.component.html',
  styleUrls: ['./send-files.component.css'],
  providers: [MessageService],
})
export class SendFilesComponent implements OnInit {
  @Input('show') Show;
  @Input('detailInfoData') fileData;
  @Output() updateShow: EventEmitter<string> = new EventEmitter<string>();
  paths: any = [];
  mailData: FormGroup;
  sendDisable: boolean;
  backendConfig :any;
  constructor(private fb: FormBuilder, public localstorage: LocalStorageService,
     private http: HttpClient, private confirmationService: ConfirmationService, 
      public session: SessionStorageService, private messageService: MessageService) { }
  ngOnInit() {
    this.mailData = this.fb.group({
      preTransFilePath: [[], Validators.required],
      postTransFilePath: [[], Validators.required],
      ackFilePath: [[], Validators.required],
      errorReportFilePath: [[], Validators.required],
      mails: [[], Validators.required],
      body: ['', Validators.required],
      subject: ['', Validators.required]
    });
    this.backendConfig = this.session.retrieve('backend_config');
  }
  ngOnChanges(){
    this.fileData=this.fileData;
   
  }
  updateChild(){
    this.mailData.reset();
  }
  updateShoW() {
    this.mailData.reset()
    this.mailData.patchValue({
      postTransFilePath:[],
      preTransFilePath:[],
      ackFilePath:[],
      errorReportFilePath:[],
    });
    this.updateShow.emit(); 
  }
  mail() {
    if (this.mailData.invalid) {
      if (!this.mailData.get('mails').invalid && !this.mailData.get('body').invalid&&!this.mailData.get('subject').invalid &&
        (this.mailData.value.preTransFilePath.length != 0 || this.mailData.value.postTransFilePath.length != 0 ||
          this.mailData.value.ackFilePath.length != 0 || this.mailData.value.errorReportFilePath.length != 0)) {
        this.sendMail();
      } else {
        const controls = this.mailData.controls;
        Object.keys(controls).forEach((key) => {
          controls[key].markAsTouched();
        });
      }

    }
    else {
      this.sendMail();
    }
  }
  sendMail() {
    this.sendDisable=true
    this.mailData.value.preTransFilePath.length != 0 ? this.paths.push(this.mailData.value.preTransFilePath[0]) : '';
    this.mailData.value.postTransFilePath.length != 0 ? this.paths=this.paths.concat(this.mailData.value.postTransFilePath[0].split(',')) : '';
    this.mailData.value.ackFilePath.length != 0 ? this.paths.push(this.mailData.value.ackFilePath[0]) : '';
    this.mailData.value.errorReportFilePath.length != 0 ? this.paths.push(this.mailData.value.errorReportFilePath[0]) : '';
    let headers = new HttpHeaders();
    headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    const mailData = {
      "filePath": this.paths,
      "toAddress": this.mailData.value.mails,
      "body": this.mailData.value.body,
      "subject":this.mailData.value.subject
    }
    this.http
      .post(
        environment.apiUrl + "/documentRepository/TransactionsDetailAttachment ",
        mailData,
        {
          headers: headers,
        }
      )
      .subscribe(
        (response: any) => {
          this.messageService.add({
            severity: response.success == true ? "success" : "error",
            detail: response.message,
          });
          if (response.success == true) {
            this.paths=[]
            setTimeout(() => {
              this.updateShoW()
              this.sendDisable=false;
            }, 2000);
          }
          else{
            this.sendDisable=false;
          }
        },
      );
  }
  validateEmail(data){
    if (!(/^\w+([\.-]?\w+)*@rehlko.com+$/.test(data.value)||/^\w+([\.-]?\w+)*@miraclesoft.com+$/.test(data.value))) {
      let mails=this.mailData.value.mails;
      this.mailData.controls.mails.patchValue(mails.slice(0,mails.length-1)) 
      this.messageService.add(
        {severity:'error', summary:'Error',detail:`${data.value} is not a valid email`}
        );
    }
}
}
